<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Solicitar firma de documento</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <mat-horizontal-stepper [linear]="true" #stepper>
            <ng-template matStepperIcon="edit" let-index="index">
                {{index +1}}
              </ng-template>
            <mat-step [stepControl]="form1">
                <ng-template matStepLabel>Firmante</ng-template>

                <h3 class="encabezadomodaltitulo mt-3">
                    AÑADIR USUARIO SOLICITANTE
                </h3>
                <p class="textosubtitulo">
                    Esta información será parte del documento a firmar y se utilizará para enviar la solicitud de firma.
                </p>
        
                <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        
                <form [formGroup]="form1">
                    <div class="row">
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Tipo identificación (*)</mat-label>
                                <mat-select formControlName="tipoDocumento" (ngModelChange)="this.Cambio_TipoDocumento()">
                                    <mat-option [value]="item.codigo" *ngFor="let item of this.listasTiposIdentificacion">{{item.descripcion}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('tipoDocumento').hasError('required')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Identificación (*)</mat-label>
                                <input matInput formControlName="nroDocumento" autocomplete="off">
                                <mat-error *ngIf="form1.get('nroDocumento').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('nroDocumento').hasError('maxlength')">La longitud máxima es 20</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="!this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Nombres (*)</mat-label>
                                <input matInput formControlName="nombres" autocomplete="off">
                                <mat-error *ngIf="form1.get('nombres').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('nombres').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="!this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Apellidos (*)</mat-label>
                                <input matInput formControlName="apellidos" autocomplete="off">
                                <mat-error *ngIf="form1.get('apellidos').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('apellidos').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 col-lg-6 col-12" *ngIf="this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Razon social (*)</mat-label>
                                <input matInput formControlName="razonSocial" autocomplete="off">
                                <mat-error *ngIf="form1.get('razonSocial').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('razonSocial').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Tipo identificación (*)</mat-label>
                                <mat-select formControlName="tipoDocumentoRepresentante">
                                    <mat-option [value]="item.codigo" *ngFor="let item of this.listasTiposIdentificacion">{{item.descripcion}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('tipoDocumentoRepresentante').hasError('required')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Identificación (*)</mat-label>
                                <input matInput formControlName="nroDocumentoRepresentante" autocomplete="off">
                                <mat-error *ngIf="form1.get('nroDocumentoRepresentante').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('nroDocumentoRepresentante').hasError('maxlength')">La longitud máxima es 20</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Nombres (*)</mat-label>
                                <input matInput formControlName="nombres" autocomplete="off">
                                <mat-error *ngIf="form1.get('nombres').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('nombres').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12" *ngIf="this.TipoIdentificacionJuridico()">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Apellidos (*)</mat-label>
                                <input matInput formControlName="apellidos" autocomplete="off">
                                <mat-error *ngIf="form1.get('apellidos').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('apellidos').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>País (*)</mat-label>
                                <mat-select formControlName="codigoPaisIndicativo">
                                    <mat-select-trigger>
                                        <div class="d-flex flex-row">
                                            <img [src]="ObtenerCodigoBandera(this.form1.get('codigoPaisIndicativo').value)">
                                            <span class="p-1">
                                                +{{ObtenerIndicativo(this.form1.get('codigoPaisIndicativo').value)}}
                                            </span>
                                        </div>
                                    </mat-select-trigger>
                                    <mat-option [value]="item.codigo" *ngFor="let item of this.listasIndicativos">
                                        <div class="d-flex flex-row">
                                            <img [src]="item.dependenciaCodigo">
                                            <span class="p-1">
                                                +{{item.id}}
                                            </span>
                                        </div>
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('codigoPaisIndicativo').hasError('required')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Número telefónico (*)</mat-label>
                                <input matInput formControlName="nroCelular" autocomplete="off">
                                <mat-error *ngIf="form1.get('nroCelular').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('nroCelular').hasError('maxlength')">La longitud máxima es 50</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-6 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Correo electrónico (*)</mat-label>
                                <input matInput formControlName="email" autocomplete="off">
                                <mat-error *ngIf="form1.get('email').hasError('required')">Campo requerido</mat-error>
                                <mat-error *ngIf="form1.get('email').hasError('maxlength')">La longitud máxima es 100</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Cliente (*)</mat-label>
                                <mat-select formControlName="idAliado" (ngModelChange)="Cambio_Aliado()">
                                    <mat-option [value]="item.id" *ngFor="let item of this.listasAliados">{{item.descripcion}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('idAliado').hasError('min')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Producto (*)</mat-label>
                                <mat-select formControlName="idProducto" (ngModelChange)="Cambio_Producto()">
                                    <mat-option [value]="item.id" *ngFor="let item of this.listasProductos">{{item.descripcion}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('idProducto').hasError('min')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-6 col-12">
                            <mat-form-field appearance="fill" class="d-block">
                                <mat-label>Documento (*)</mat-label>
                                <mat-select formControlName="idProductoFirma" (ngModelChange)="Cambio_DocumentoFirma()">
                                    <mat-option [value]="item.id" *ngFor="let item of this.listasDocumentos">{{item.descripcion}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form1.get('idProductoFirma').hasError('min')">Campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
        
                </form>
        
                <div class="d-flex flex-row-reverse" *ngIf="!this.mostrarPaso4">
                    <div class="p-1">
                        <button type="button" class="botoncompleto" (click)="GuardadoPaso1()" matStepperNext>
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botoncompletoicono">keyboard_arrow_right</mat-icon>
                                <span class="botoncompletotexto">Siguiente</span>
                            </div>
                        </button>
                    </div>
                    <div class="p-1">
                        <button type="button" class="botonatras" (click)="LimpiarPaso1()">
                            <span class="botoncompletotexto">Limpiar</span>
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step [completed]="this.PasoDatosComplementariosValidos()">
                <ng-template matStepLabel>Datos adicionales</ng-template>
        
                <h3 class="encabezadomodaltitulo mt-3">
                    INFORMACIÓN ADICIONAL
                </h3>
                <p class="textosubtitulo">
                    Esta información será parte del documento a firmar y será diligenciada en el formato respectivamente.
                </p>
    
                <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
    
                <div class="row pr-0 pl-0 mt-4 m-0">
                    <div class="col-md-6 col-lg-6 col-12" *ngFor="let itemCampo of this.listaFirmaElectronicaCampos">
                        <mat-form-field appearance="fill" class="d-block" *ngIf="this.MostrarTipoCampoTexto(itemCampo.tipoCampo) && this.MostrarCampoDependiente(itemCampo.codigoCampo)">
                            <mat-label>{{itemCampo.descripcionCampo}}</mat-label>
                            <input matInput [formControl]="itemCampo.campoFormulario" autocomplete="off" (ngModelChange)="this.CambioItemFormularioDinamico(itemCampo)">
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="d-block" *ngIf="(this.MostrarTipoCampoNumerico(itemCampo.tipoCampo) || this.MostrarTipoCampoNumero(itemCampo.tipoCampo)) && this.MostrarCampoDependiente(itemCampo.codigoCampo)">
                            <mat-label>{{itemCampo.descripcionCampo}}</mat-label>
                            <input matInput [formControl]="itemCampo.campoFormulario" autocomplete="off" type="number" (ngModelChange)="this.CambioItemFormularioDinamico(itemCampo)">
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="d-block" *ngIf="this.MostrarTipoCampoFecha(itemCampo.tipoCampo) && this.MostrarCampoDependiente(itemCampo.codigoCampo)">
                            <mat-label>{{itemCampo.descripcionCampo}}</mat-label>
                            <input matInput [matDatepicker]="pickerFechaDinamica"  [formControl]="itemCampo.campoFormulario" autocomplete="off" (ngModelChange)="this.CambioItemFormularioDinamico(itemCampo)">
                            <mat-datepicker-toggle matSuffix [for]="pickerFechaDinamica"></mat-datepicker-toggle>
                            <mat-datepicker #pickerFechaDinamica></mat-datepicker>
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="d-block" *ngIf="this.MostrarTipoCampoSiNo(itemCampo.tipoCampo) && this.MostrarCampoDependiente(itemCampo.codigoCampo)">
                            <mat-label>{{itemCampo.descripcionCampo}}</mat-label>
                            <mat-select [formControl]="itemCampo.campoFormulario" (ngModelChange)="this.CambioItemFormularioDinamico(itemCampo)">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="d-block" *ngIf="this.MostrarTipoCampoLista(itemCampo.tipoCampo) && this.MostrarCampoDependiente(itemCampo.codigoCampo)">
                            <mat-label>{{itemCampo.descripcionCampo}}</mat-label>
                            <mat-select [formControl]="itemCampo.campoFormulario" (ngModelChange)="this.CambioItemFormularioDinamico(itemCampo)">
                                <mat-option [value]="item.codigo" *ngFor="let item of itemCampo.listaDatos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="itemCampo.campoFormulario.hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
    
                <div class="d-flex flex-row-reverse" *ngIf="!this.mostrarPaso4">
                    <div class="p-1">
                        <button type="button" class="botoncompleto" (click)="GuardadoPas2()">
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botoncompletoicono">keyboard_arrow_right</mat-icon>
                                <span class="botoncompletotexto">Siguiente</span>
                            </div>
                        </button>
                    </div>
                    <div class="p-1">
                        <button type="button" class="botonatras" (click)="AtrasPaso2()" matStepperPrevious>
                            <span class="botoncompletotexto">Atras</span>
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step [stepControl]="form2" *ngIf="mostrarPaso3">
                <ng-template matStepLabel>Validación</ng-template>

                <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>

                <div class="d-flex flex-column">
                    <div class="d-flex justify-content-center">
                        <h3 class="encabezadomodaltituloconfirmacion mt-3">
                            Ingresa el código
                        </h3>
                    </div>
                    <div class="d-flex justify-content-center">
                        <p class="textosubtituloconfirmacion">
                            Enviamos un código SMS al móvil {{this.form1.get('nroCelular')?.value}}
                        </p>
                    </div>

                    <div class="d-flex justify-content-center">
                        <form [formGroup]="form2">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-12">
                                    <mat-form-field appearance="fill" class="d-block">
                                        <mat-label>Código de autorización (*)</mat-label>
                                        <input matInput formControlName="codigoAutorizacion" autocomplete="off" (keydown)="onKeyDownCodigoAutorizacion($event)">
                                        <mat-error *ngIf="form2.get('codigoAutorizacion').hasError('required')">Campo requerido</mat-error>
                                        <mat-error *ngIf="form2.get('codigoAutorizacion').hasError('maxlength')">La longitud máxima es 6</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="d-flex justify-content-center" *ngIf="mostrarReenviarCodigo">
                        <p>¿No recibiste el código? <b><a type="button" (click)="ReenviarCodigoAutorizacion()">Click para reenviar</a></b></p>
                    </div>
                    <div class="d-flex justify-content-center" *ngIf="!mostrarReenviarCodigo">
                        <p>Reenviar código en {{this.tiempoReenviarCodigo}}</p>
                    </div>
                </div>
              
                <div class="d-flex flex-row-reverse" *ngIf="!this.mostrarPaso4">
                    <div class="p-1">
                        <button type="button" class="botoncompleto" (click)="GuardadoPaso3()">
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botoncompletoicono">keyboard_arrow_right</mat-icon>
                                <span class="botoncompletotexto">Siguiente</span>
                            </div>
                        </button>
                    </div>
                    <div class="p-1">
                        <button type="button" class="botonatras" (click)="AtrasPaso3()">
                            <span class="botoncompletotexto">Atras</span>
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Confirmación</ng-template>
              
                <div class="d-flex flex-column">
                    <div class="d-flex justify-content-center">
                        <div class="ico">
                            <mat-icon aria-hidden="false" aria-label="Example home icon">check</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <h4 class="confirmafiliaciontitulo">Confirmado</h4>
                    </div>
                    <div class="d-flex justify-content-center">
                        <h4 class="mensajeconfirmaciontexto"><strong>!En hora buena!</strong></h4>
                    </div>
                    <div class="d-flex justify-content-center">
                        <h4 class="mensajeconfirmaciontexto"><strong *ngIf="!this.TipoIdentificacionJuridico()">{{this.form1.get('nombres').value}} {{this.form1.get('apellidos').value}} /  {{this.form1.get('nroDocumento').value}}</strong></h4>
                    </div>
                    <div class="d-flex justify-content-center">
                        <h4 class="mensajeconfirmaciontexto"><strong *ngIf="this.TipoIdentificacionJuridico()">{{this.form1.get('nombres').value}} /  {{this.form1.get('nroDocumento').value}}</strong></h4>
                    </div>
                    
                    <div class="d-flex justify-content-center">
                        <div class="mensajeconfirmacion">
                            <div class="d-flex flex-column">
                                <div class="d-flex justify-content-center">
                                    <h1>¡Enviado!</h1>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <p>Fue enviado un documento para su firma electrónica.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>

